/**
 * Multilingual Handlefrs.
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function($) {

    /*
     * Toggle Language Seitch Hanfler
     */
    $('.toggle-language').on('change', function(e) {
        var curr_code = $(this).data('lang');
        var location  = $(this).data('location');
        var curr_lang = $('#lang-' + curr_code + '-' + location);
        $(this).next().attr('data-name', curr_lang.data('name'));
        var prev_code = $(this).next().data('lang');
        var prev_lang = $('#lang-' + prev_code + '-' + location);
        $(this).attr('data-lang', prev_code);
        window.location.href = prev_lang.data('url');
    });
});